/** The docs landing page: what is here, the deployment models and the generated views. */
import type { Instruction } from '@crown/framework/ir';
import template from './home.tsrx';

const Home: (props: Record<string, never>) => Instruction = template;

export function HomePage(): Instruction {
  return Home({});
}
